import {
  ADD_USER,
  DELETE_USER,
  EDIT_USER,
  SET_LOADING,
  SET_USERS,
} from '../actions/users';

export default (
  state = {
    users: [],
    loading: null,
  },
  { type, data }
) => {
  switch (type) {
    case SET_LOADING:
      return { ...state, loading: data };
    case ADD_USER:
      return { ...state, users: [data, ...state.users] };
    case SET_USERS:
      return { ...state, users: [...data] };
    case DELETE_USER:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== data),
      };
    case EDIT_USER:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === data.id ? { ...data } : user
        ),
      };
    default:
      return state;
  }
};
